export enum BackgroundJobType {
  FileUpload = "FILE_UPLOAD",
  StatusChange = "STATUS_CHANGE",
  Submit = "SUBMIT",
}
